export default __webpack_public_path__ + "static/media/UserManual_01122022.d3ca30ed.pdf";